import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function NotificationModal({ notification, show, onHide }) {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {notification.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{ width: '100%' }}
            dangerouslySetInnerHTML={{
              __html: `
                <style>
                  img { max-width: 100% }
                  p { word-break: break-word }
                </style>
                ${notification.contentText}
              `
            }}
          />
            
          {/* {notification.contentText} */}
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            variant="default"
            onClick={onHide}
          >
            {t('general.close')}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  )
};

export default NotificationModal;